module.exports = __webpack_public_path__ + "static/media/university.2a143d31.svg";